import { themes } from "../datas/logo-datas";

export const getDomain = (): string | undefined => {
    const url = window.location.hostname;
    const theme = themes.find(x => x.key == url);
    const value = theme?.domain;
    return value;
  }